/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {service as PermissionService} from "../../../Services/PermissionService";
import {FormCheck} from "react-bootstrap";
import React from "react";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";

export const UserPermissionFieldEditor = (props) => {
	
	const {Value, OnUpdate, Data } = props;
	
	usePrimeCache([PermissionService]);
	
	const permission = PermissionService.CachedValueById(Value)?.result;
	
	return <FormCheck
		type="checkbox"
		id={'permission' + permission?.permissionId}
		label={permission?.name}
		style={{margin: 0}}
		checked={Data.value}
		onChange={(x) => {
			OnUpdate(permission.permissionId);
		}}
	/>;
}
